// form
import { useFormContext, Controller } from "react-hook-form";
// @mui
import { TextField, TextFieldProps } from "@mui/material";
import InputMask from "react-input-mask";

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  mask?: string; // máscara opcional
};

export default function RHFTextField({ name, mask, helperText, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        // remove 0 inicial se for number
        const value =
          typeof field.value === "number" && field.value === 0 ? "" : field.value;

        if (mask) {
          return (
            <InputMask
              mask={mask}
              value={value}
              onChange={field.onChange}
              maskChar=""
            >
              {(inputProps: any) => (
                <TextField
                  {...inputProps}
                  fullWidth
                  error={!!error}
                  helperText={error ? error.message : helperText}
                  {...other}
                />
              )}
            </InputMask>
          );
        }

        return (
          <TextField
            {...field}
            fullWidth
            value={value}
            error={!!error}
            helperText={error ? error.message : helperText}
            {...other}
          />
        );
      }}
    />
  );
}
